import { queryOptions, useQuery } from "@tanstack/react-query";
import { NoteVault } from "@/lib/types";
import { useUser } from "@/hooks/useUserProvider";
import { normalizeRequestError } from "@/lib/errors";
import { request } from "@/lib/request";

// Shared key+fn so the boot prefetch (main.tsx) and the hook dedupe.
export const noteVaultsQueryOptions = () =>
  queryOptions({
    queryKey: ["notes", "vaults"] as const,
    queryFn: async (): Promise<NoteVault[]> => {
      const res = await request
        .get("/internal/notes/vaults")
        .catch(
          normalizeRequestError("Something went wrong, please try again."),
        );

      return res.data.data;
    },
  });

export const useGetNoteVaults = () => {
  const { accessToken } = useUser();
  return useQuery({
    ...noteVaultsQueryOptions(),
    enabled: !!accessToken,
  });
};
